export default (state = {}, action = {}) => {
  const {type, payload = {}} = action;
  switch (type) {
    default: {
      if (payload.trip_status) {
        return {...state, ...payload.trip_status};
      }
      return state;
    }
  }
};
